/*
 * Add to Apple Wallet / Google Wallet (CLAUDE.md §4, docs/23 §3.2). The pass carries the same as the Card tab, with one
 * fixed barcode. The server makes the pass; the app asks for a short-lived link and hands it to the phone.
 */
import { api, ApiError } from './api.js';
import { openExternal } from './open.js';
import { NATIVE, PLATFORM } from './platform.js';

export type WalletKind = 'apple' | 'google';

/** Which wallet this device has: Apple on iPhones (and iPads), Google on Android, both on other computers. */
export function deviceWallets(): WalletKind[] {
  if (NATIVE) return PLATFORM === 'android' ? ['google'] : ['apple'];
  const ua = navigator.userAgent;
  if (/Android/.test(ua)) return ['google'];
  if (/iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return ['apple'];
  if (/Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua)) return ['apple'];
  return ['apple', 'google'];
}

/** Ask the server for the pass and open it (Apple: the .pkpass link; Google: the "Save to Google Wallet" link). Returns an error to show, or null. */
export async function addToWallet(kind: WalletKind): Promise<string | null> {
  try {
    const r = await api<{ url: string }>(`/api/me/wallet/${kind}`, { body: {} });
    if (!r.url) return 'Could not make your pass. Try again.';
    await openExternal(r.url);
    return null;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return 'Wallet passes open soon.';
    return e instanceof Error ? e.message : 'Could not make your pass';
  }
}
